import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { Alert, Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { usePlaidLink } from "react-plaid-link";
import { get, post } from "../../api/";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { updateCurrentScreen } from "../../utils";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { ReactComponent as IncomeImage } from "../../assets/svgs/connect-bank-accounts.svg";
import { PlaidOtherLink } from "../PlaidOtherLink";
let count = 0;
let config = {};
let linkData;
const FinancialAccount = forwardRef((props, ref) => {
    const navigate = useNavigate();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();

    const [status, setStatus] = useState("");
    const [loadingDetails, setLoadingDetails] = useState(false);

    const handleOtherEvent = (event) => {
        if (event.detail.type === "Success") {
            setStatus("Success");
            const updateUserDetails = new CustomEvent("updateUserDetails", {
                detail: { type: "Success" },
            });
            document.dispatchEvent(updateUserDetails);
            handleChange(true);
            setLoadingDetails(false);
            setTimeout(() => {
                document.querySelector("#next-btn").click();
            }, 3000);
        } else if (event.detail.type === "In Progress") {
            setLoadingDetails(true);
        } else {
            setStatus("Error");
            handleChange(false);
            setLoadingDetails(false);
        }
    };

    useEffect(() => {
        document.addEventListener("plaidOtherEvent", handleOtherEvent);
        return () => {
            document.removeEventListener("plaidOtherEvent", handleOtherEvent);
        };
    }, []);

    useImperativeHandle(ref, () => ({
        validate,
    }));

    const validate = () => {
        let hasError = false;
        if (!userDetails.applicant.plaidOtherVerified) {
            hasError = true;
        }

        return !hasError;
    };

    const handleChange = (value) => {
        props.onChange(value);
    };

    return (
        <>
            <>
                {loadingDetails && (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <CircularProgress
                            color="success"
                            sx={{ width: "60px !important", height: "60px !important" }}
                            thickness="3.9"
                        />

                        <Typography variant="h6" component="div" sx={{ mt: "1rem", textAlign: "center" }}>
                            Loading account information. This may take a minute!
                        </Typography>
                    </Box>
                )}
                {status === "Failed" && (
                    <Alert severity="error">
                        There is was an error while loading account details, please try again later.
                    </Alert>
                )}
                {status === "Success" && (
                    <Alert severity="success">Successfully retrieved bank account information.</Alert>
                )}
                {!loadingDetails && status !== "Success" && (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            my: "3rem",
                        }}
                    >
                        <IncomeImage style={{ width: "200px" }}></IncomeImage>
                        {/* <Typography variant="h5" component="div" sx={{ mt: "1rem", textAlign: "center" }}>
                            <b>Please provide your Financial Details</b>
                        </Typography> */}
                        <Typography variant="h6" component="div" sx={{ mt: ".5rem", textAlign: "center" }}>
                        We use Plaid to securely connect with your bank in order to check account balances and verify income deposits. If you have any issues connecting to your bank account please contact us at 877-958-1888.
                        </Typography>
                        <Box sx={{ mt: "2rem" }}>
                            <PlaidOtherLink></PlaidOtherLink>
                        </Box>
                    </Box>
                )}
            </>
        </>
    );
});

export { FinancialAccount };
